import React, { useLayoutEffect } from 'react';
import { useAsyncValue, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import debug from 'debug';

// Components
import OperatorsAndVehicleForm from '../../../../../components/forms/ActionForms/OperatorsAndVehicles';

// Constants
import { formActionValidationNaming } from '../../../../../components/forms/ActionForms/constants';

// Types
import { type OperatorsAndVehiclesFormValues } from '../../../../../components/forms/ActionForms/OperatorsAndVehicles/types';
import { OrderActionReferences } from '../types';
import { Role } from '../../../../../types/auth';

// Redux
import { roidOTSelected } from '../../../../../state/actions/ui/roidOTSelectedGeneralView';

// Hooks
import { useAuth } from '../../../../../hooks/useAuth';

// Debug loggers
const logPage = debug('rois:page:operators-vehicles-validation');
const logPageData = debug('rois:page:operators-vehicles-validation:data');

export default function OperatorsAndVehiclesFormValidationPage(): JSX.Element {
  const { t } = useTranslation('validation');
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const loaderData = useAsyncValue() as OperatorsAndVehiclesFormValues &
    OrderActionReferences;

  // Get current user role - RoomTeam can only view, not edit
  const { user } = useAuth();
  const isReadOnly = user?.user?.rolActive === Role.RoomTeam;

  // Debug: datos que llegan al componente
  logPage('═══ OperatorsAndVehiclesFormValidationPage RENDER ═══');
  logPage('loaderData recibido:', loaderData ? 'SÍ' : 'NO');
  logPageData('operatorsTable:', loaderData?.operatorsTable?.length || 0, 'operarios');
  logPageData('vehicleTable:', Object.keys(loaderData?.vehicleTable || {}).length, 'vehículos');
  logPageData('orderId:', loaderData?.orderId);
  logPageData('roid:', loaderData?.roid);
  if (loaderData?.operatorsTable?.length > 0) {
    loaderData.operatorsTable.forEach((op: any, idx: number) => {
      logPageData(`  [${idx}] ${op?.name || 'sin nombre'} ${op?.surName || ''} - id: ${op?.id}`);
    });
  } else if (loaderData?.operatorsTable?.length === 0) {
    logPage('⚠️ operatorsTable está VACÍO en la página');
  }

  const onFormSubmit = async () => {
    if (isReadOnly) return; // RoomTeam cannot submit
    navigate('../location');
  };

  useLayoutEffect(() => {
    dispatch(
      roidOTSelected('actions-validation', loaderData.roid!, loaderData.orderId)
    );
  }, []);

  return (
    <OperatorsAndVehicleForm
      onFormSubmit={isReadOnly ? () => {} : onFormSubmit}
      initialData={loaderData}
      namingPersistForm={
        formActionValidationNaming.NEW_VALIDATION_OPERATORS_AND_VEHICLE_FORM
      }
      textButton={isReadOnly ? t('viewOnly') : user?.user?.rolActive === Role.Tablet ? t('buttons:continue') : t('validate')}
    />
  );
}
